import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { UserService } from "src/app/core/services/v2/user.service";
import { SetupService } from "src/app/physician/setup/setup.service";
import { CaseManagerBaseLayout } from "../CaseManagerBaseLayout";

@Component({
  selector: "app-casemanager-layout",
  templateUrl: "./casemanager-layout.component.html",
  styleUrls: ["./casemanager-layout.component.scss"],
})
export class CasemanagerLayoutComponent extends CaseManagerBaseLayout {

  constructor(private practiceService: PracticeService, private userService: UserService, private router: Router,
    private setupService: SetupService) {
    super(practiceService, userService, router, setupService);
    this.showPhysicianSelector = true;
  }
}

//   expandNav = false;
//   constructor() { }

//   ngOnInit() {
//   }

//   expandSidebar(event) {
//     if (event.type === 'mouseover') {
//       this.expandNav = true;
//     } else {
//       this.expandNav = false;
//     }
//   }

// }
